/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const PaymentStatus = {
  Capturable: "CAPTURABLE",
  Pending: "PENDING",
  Cancelled: "CANCELLED",
  Successful: "SUCCESSFUL",
  Failed: "FAILED",
  Refunded: "REFUNDED",
  PartiallyRefunded: "PARTIALLY_REFUNDED",
} as const;

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

export type PaymentStatusEnumType = typeof PaymentStatus;
export type PaymentStatusOptional = PaymentStatus;
export type PaymentStatusTrackedI = PaymentStatus;
export type PaymentStatusTracked = PaymentStatus;
export type PaymentStatusMetaI = EnumMetaType<
  PaymentStatusEnumType,
  PaymentStatus
>;
export const PaymentStatusMeta = typeMetaEnum<
  PaymentStatusEnumType,
  PaymentStatus
>("PaymentStatus", PaymentStatus);
export function transformDatesPaymentStatus(model: PaymentStatus) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
